import { render } from "./BackupContent.vue?vue&type=template&id=a13eb254"
import script from "./BackupContent.vue?vue&type=script&lang=js"
export * from "./BackupContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__